import helpers from "./common";

export default ({ app }, inject) => {
  inject("helpers", helpers(app));
};
